import { useForm } from 'react-hook-form';
import { Field } from '~/components/shared/Field';
import { useTranslation } from 'react-i18next';
import PhoneInputWithCountrySelect from 'react-phone-number-input';
import { ProfileImage } from '~/components/shared/ProfileImage';
import Camicon from '~/assets/svg/camicon.svg';
import { TranslateButton } from '~/components/shared/TranslateButton';
import { useGetOwner } from '~/services/auth';

interface IProfilePageProps {
  // typescript
  firstName?: string;
  lastName?: string;
  email: string;
  phoneNumber?: string;
}

export const ProfilePage = ({
  firstName = '',
  lastName = '',
  email,
  phoneNumber = '',
}: IProfilePageProps) => {
  // cualquier propiedad
  const [t] = useTranslation('profile_page');
  const { data, loading, error } = useGetOwner();
  const owner = data?.response?.data;

  const { register, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      first_name: owner?.first_name || firstName,
      phone_number: owner?.phoneNumber || phoneNumber,
      email: owner?.email || email,
      last_name: owner?.last_name || lastName,
    },
  });

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading profile</div>;

  return (
    <div className="mt-8 h-fit w-full rounded-lg bg-base-100 pb-14 md:h-full  md:pb-0">
      <div className="ml-4 flex flex-col items-center justify-between gap-4 pt-6 md:flex-row">
        <p className="self-start text-lg font-bold">{t('title')}</p>
      </div>
      <div className="mt-8 flex w-full flex-col md:flex-row">
        <div className="flex w-full items-center justify-center md:w-60">
          <ProfileImage size="lg" />
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex w-full flex-col px-4">
            <div className="flex w-full flex-row gap-4">
              <Field
                label={t('first_name')}
                type="readonly"
                fieldName="first_name"
                register={register}
                placeholder="Jorge"
              ></Field>

              <Field
                label={t('email')}
                fieldName="email"
                type="readonly"
                register={register}
                placeholder="charles.martinez@gmail.com"
              ></Field>
            </div>
            <div className="w-full">
              <div className="flex w-full flex-col">
                {/* <span className="label-text py-2 font-bold">
                {t('cell_phone_number')}
              </span>
              <PhoneInputWithCountrySelect
                value={watch('phone_number')}
                defaultCountry="CO"
                className={`input input-bordered w-full transition-all`}
                onChange={(value) => setValue('phone_number', value as string)}
              /> */}
              </div>
              <div className="flex w-full flex-col"></div>
            </div>
            {/* <p className="mt-4 text-xs">{t('paragraph')}</p> */}
          </div>
          <div className="flex w-full px-4">
            <div className="w-40">
              <TranslateButton updateOwnerOnChange />
            </div>
          </div>
        </div>
      </div>
      <div className="mr-4 mt-8 flex justify-end pb-8">
        {/* <button className="btn w-[200px] rounded-full bg-button-100 text-white">
          {t('button_save')}
        </button> */}
      </div>
    </div>
  );
};
